/**
 * PreviewCtrl controller
 */
const posters = (new Array(7).fill(' ')).map(() => new window.Image())
// controller mixins
PreviewCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * PreviewCtrl controller
 *
 * @class PreviewCtrl
 * @memberof mwApp/promotion
 * @see mwApp/promotion
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/promotion.controller:PreviewCtrl
 */
/* @ngInject */
export default function PreviewCtrl ($scope, scope) {
  const vm = this
  vm.rows = new Array(1)
  vm.centralRowIndex = Math.floor(vm.rows.length / 2)
  vm.selectedRow = vm.config = {
    title: 'Continue Watching Settings',
    description: 'Some description ome description ome description',
    posterOrientation: 'HORIZONTAL',
    posterSize: 'S'
  }

  vm.mainRow = {
    LIVE: posters.map((img, index) => ({ ...img, src: require(`./content/LIVE/l${index}.png`) })),
    HORIZONTAL: posters.map((img, index) => ({ ...img, src: require(`./content/posters/h/h${index}.png`) })),
    VERTICAL: posters.map((img, index) => ({ ...img, src: require(`./content/posters/v/v${index}.png`) }))
  }

  vm.getDigitsImgSrc = function (position) {
    if (position) { return require(`./img/${Math.min(position, 6)}.png`) }
  }

  vm.getHintsImgSrc = function (filename) {
    if (filename) { return require(`./img/hints/${filename}`) }
  }

  vm.getMainRow = function () {
    return vm.selectedRow?.labels?.includes('LIVE') ? vm.mainRow.LIVE : vm.mainRow[vm.selectedRow.posterOrientation]
  }

  vm.cardTypes = { p: 'posters', ch: 'channels', HORIZONTAL: 'h' }

  vm.setImage = function (position, platform) {
    if (position && platform) { return require(`./content/secondaryRows/${position}_row_${platform}.png`) }
  }

  vm.previewTabs = {
    stb: {
      icon: 'fa-television',
      iconSize: 14,
      index: 0,
      navbar: true,
      textWidth: '580px',
      emptyText: {
        OTHER: {
          info: 'Adventure Game: Shadows of Destiny',
          title: ' A murder has been committed... your own! Travel back in time to solve thought provoking puzzles as you unravel the mystery of your death.'
        },
        HORIZONTAL: {
          info: 'Shadows of Destiny',
          title: 'A young man, his name is Eike Kusch, walks out of a coffee shop somewhere in Europe and gets stabbed in the back by an unknown person. But he is not dead.'
        },
        VERTICAL: {
          info: 'Shadows of Destiny',
          title: 'A young man, his name is Eike Kusch, walks out of a coffee shop somewhere in Europe and gets stabbed in the back by an unknown person. But he is not dead.'
        }
      },
      display: {
        aspectRatio: 1.7756,
        cardSizes: {
          VERTICAL: { S: { w: 83.59, h: 125.39 }, M: { w: 101.42, h: 152.14 }, L: { w: 128, h: 192 } },
          HORIZONTAL: { S: { w: 128.4, h: 72.22 }, M: { w: 171.31, h: 96.36 }, L: { w: 261.84, h: 147.28 } },
          gap: ''
        }
      }
    },
    laptop: {
      icon: 'fa-laptop',
      iconSize: 14,
      index: 1,
      textWidth: '580px',
      display: {
        aspectRatio: 1.7756,
        cardSizes: {
          VERTICAL: { S: { w: 81.78, h: 111.17 }, M: { w: 96.3, h: 130.91 }, L: { w: 116.63, h: 158.55 } },
          HORIZONTAL: { S: { w: 116.63, h: 65.6 }, M: { w: 147.12, h: 82.76 }, L: { w: 197.95, h: 111.35 } },
          CHANNELS: { L: { w: 116.63, h: 65.6 }, M: { w: 96.3, h: 54.17 }, S: { w: 81.78, h: 46 } },
          gap: ''
        }
      }
    },
    tablet: {
      icon: 'fa-tablet',
      iconSize: 17,
      index: 2,
      textWidth: '500px',
      display: {
        aspectRatio: 1.5035,
        cardSizes: {
          VERTICAL: { S: { w: 79.69, h: 119.53 }, M: { w: 121.36, h: 181.03 }, L: { w: 162.95, h: 244.42 } },
          HORIZONTAL: { S: { w: 121.36, h: 68.26 }, M: { w: 163.02, h: 91.7 }, L: { w: 246.25, h: 138.51 } },
          gap: ''
        }
      }
    },
    mobile: {
      icon: 'fa-mobile',
      iconSize: 18,
      index: 3,
      textWidth: '160px',
      display: {
        aspectRatio: 0.472,
        cardSizes: {
          VERTICAL: { S: { w: 60.14, h: 90.21 }, M: { w: 92.49, h: 138.73 }, L: { w: 124.38, h: 186.8 } },
          HORIZONTAL: { S: { w: 92.49, h: 52.03 }, M: { w: 92.49, h: 52.03 }, L: { w: 124.38, h: 69.96 } },
          gap: ''
        }
      }
    }
  }

  vm.semplerNav = {
    search: { icon: 'fa-search', name: 'Search', preview: { stb: true } },
    home: { icon: 'fa-home', name: 'Home', preview: { stb: true, laptop: true, tablet: true, mobile: true } },
    tv: { icon: 'fa-tv', name: 'Live', preview: { stb: true, laptop: true, tablet: true, mobile: true } },
    discovery: { icon: 'fa-film', name: 'Movies', preview: { stb: true, laptop: true, tablet: true, mobile: true } },
    search2: { icon: 'fa-search', name: 'Search', preview: { tablet: true, mobile: true } },
    series: { icon: 'fa-clone', name: 'Series', preview: { stb: true, laptop: true } },
    list_2: { icon: 'fa-bars', name: 'EPG', preview: { stb: true } },
    catchup: { icon: 'fa-history', name: 'Catchups', preview: { stb: true } },
    activity: { icon: 'fa-caret-square-o-right', name: 'Events', preview: { stb: true } },
    bookmark: { icon: 'fa-bookmark', name: 'My List', preview: { stb: true } },
    more: { name: 'More', preview: { laptop: true } }
  }

  vm.samplerNotifications = {
    search: { icon: 'fa-search', name: 'Search', preview: { laptop: true } },
    bell: { icon: 'fa-bell', name: 'Bell', preview: { stb: true, laptop: true } },
    load: { icon: 'fa-download', preview: { laptop: true } }
  }

  // const platforms = Object.keys(vm.previewTabs)

  // vm.topRow = platforms.reduce((acc, platform) => ({...acc, [platform]:}), {})

  vm.makeMainBackground = function (platform = false) {
    if (platform && vm.displayStbEmpty(platform)) {
      return `url(${vm.mainRow[vm.selectedRow.posterOrientation][0].src}) center/cover no-repeat`
    }

    if (vm.selectedRow?.backgroundStyle?.type === 'GRADIENT' && vm.selectedRow?.backgroundStyle?.gradientConfig) {
      return `linear-gradient(${vm.selectedRow?.backgroundStyle?.gradientConfig?.angle}deg, ` +
      vm.selectedRow?.backgroundStyle?.gradientConfig.colors.map(color => (color.color + ' ' + color.percentage + '%')).join(', ') + ')'
    }

    if (vm.selectedRow?.backgroundStyle?.type === 'IMAGE' && vm.selectedRow?.backgroundStyle?.imageUrl) {
      return `url(${vm.selectedRow?.backgroundStyle?.imageUrl}) center/cover no-repeat`
    }
  }

  vm.displayStbEmpty = function (platform) {
    return platform === 'stb' && !vm.selectedRow.description && !vm.selectedRow.labels?.includes('LIVE') && vm.selectedRow?.posterSize === 'S' &&
      (!vm.selectedRow?.backgroundStyle || vm.selectedRow?.backgroundStyle.type === 'UNSET')
  }

  scope.dispatchRow = function (row) {
    vm.selectedRow = row || {}
  }
  const hostRow = scope.selectedRow
  if (hostRow && (hostRow.type || hostRow.id || hostRow.$uuid)) {
    scope.dispatchRow(hostRow)
  }
}
